import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Styled from './block-selector-component-style';

/**
 * Block Selector component to display block tabs and their content.
 * @param {object} props The component props.
 * @param {Array} props.tabs The block tabs to display.
 * @property {string} props.tabs.label The label.
 * @property {JSX.Element} props.tabs.content The content to display.\
 * @param {number} props.selectedTab The selected tab index.
 * @returns {JSX.Element} The rendered Block Selector component.
 */
const BlockSelector = ({ tabs, selectedTab }) => {
  const [activeTab, setActiveTab] = useState(selectedTab);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <>
      <Styled.TabContainer>
        {tabs.map((tab, index) => (
          <Styled.Tab
            $hasError={tab.hasError}
            type="button"
            key={tab.label}
            $active={index === activeTab}
            onClick={() => handleTabClick(index)}
          >
            <Styled.Label
              $active={index === activeTab}
              $hasError={tab.hasError}
            >
              {tab.label}
            </Styled.Label>
          </Styled.Tab>
        ))}
      </Styled.TabContainer>
      {tabs.map((tab, index) => (
        <Styled.DisplayActiveContent $active={index === activeTab}>
          {tab.content}
        </Styled.DisplayActiveContent>
      ))}
    </>
  );
};

BlockSelector.propTypes = {
  tabs: PropTypes.shape({
    map: PropTypes.func,
  }),
  selectedTab: PropTypes.number,
};

BlockSelector.defaultProps = {
  tabs: [],
  selectedTab: 0,
};

export default BlockSelector;
